export default "__VITE_ASSET__COphakXu__"